import * as CONSTANT from "../../utils/actionTypes";
import UNIVERSAL from "../../utils/config";
import { setLoader, unsetLoader } from "../../store/actions/loaderActions";
import { set_snack_bar } from "../../store/actions/snackbarActions";
import "firebase/storage";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";

export function UploadaddLink(
  token,
  user_id,
  Facebook,
  Instagram,
  WhatsApp,
  Browser,
  Snapchat,
  GoogleMaps,
  Twitter,
  LinkedIn,
  Telegram,
  YouTube,
  Pinterest,
  PDFDownloader,
  profileImage,
  coverImage,
  heading,
  mediaType,
  mobile,
  BusinessWhatsApp,
  Skype,
  massenger,
  wechat,
  FaceTime,
  showAllReviews,
  tagLine,
  insertedBy
) {
  return (dispatch) => {
    dispatch(setLoader(true)); // Show loader


    if (profileImage) {
      const validImageTypes = [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "image/webp",
      ]; // Allowable file types
      if (!validImageTypes.includes(profileImage.type)) {
        dispatch(
          set_snack_bar(
            true,
            "Invalid image type. Only JPEG, PNG, and JPG are allowed."
          )
        );
        dispatch(setLoader(false));
        return;
      }


      const imageName = `${profileImage.name}-${Math.random()
        .toString(36)
        .substr(2, 9)}`;
      const storageRef = ref(getStorage(), `/uploads/${imageName}`);


      const uploadTask = uploadBytesResumable(storageRef, profileImage);

      uploadTask.on(
        "state_changed",
        (snapshot) => { },
        (error) => {
          console.error("Image upload failed:", error);
          dispatch(set_snack_bar(true, "Image could not be uploaded."));
          dispatch(setLoader(false)); // Hide loader on error
        },
        () => {

          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            dispatch(
              UploadsaddLink(
                token,
                user_id,
                Facebook,
                Instagram,
                WhatsApp,
                Browser,
                Snapchat,
                GoogleMaps,
                Twitter,
                LinkedIn,
                Telegram,
                YouTube,
                Pinterest,
                PDFDownloader,
                downloadURL, // Pass the profile image URL
                coverImage,
                heading,
                mediaType,
                mobile,
                BusinessWhatsApp,
                Skype,
                massenger,
                wechat,
                FaceTime,
                showAllReviews,
                tagLine,
                insertedBy
              )
            );
            dispatch(set_snack_bar(true, "Image uploaded successfully."));
            dispatch(setLoader(false)); // Hide loader
          });
        }
      );
    } else {

      dispatch(
        UploadsaddLink(
          token,
          user_id,
          Facebook,
          Instagram,
          WhatsApp,
          Browser,
          Snapchat,
          GoogleMaps,
          Twitter,
          LinkedIn,
          Telegram,
          YouTube,
          Pinterest,
          PDFDownloader,
          profileImage, // Pass the profile image URL
          coverImage,
          heading,
          mediaType,
          mobile,
          BusinessWhatsApp,
          Skype,
          massenger,
          wechat,
          FaceTime,
          showAllReviews,
          tagLine,
          insertedBy
        )
      );
      dispatch(set_snack_bar(true, "Please upload a profile image."));
      dispatch(setLoader(false));
    }
  };
}

export function UploadsaddLink(
  token,
  user_id,
  Facebook,
  Instagram,
  WhatsApp,
  Browser,
  Snapchat,
  GoogleMaps,
  Twitter,
  LinkedIn,
  Telegram,
  YouTube,
  Pinterest,
  PDFDownloader,
  profileImage,
  coverImage,
  heading,
  mediaType,
  mobile,
  BusinessWhatsApp,
  Skype,
  massenger,
  wechat,
  FaceTime,
  showAllReviews,
  tagLine,
  insertedBy
) {
  return (dispatch) => {
    dispatch(setLoader(true)); // Show loader


    if (typeof coverImage === "string") {

      dispatch(
        addLink(
          token,
          user_id,
          Facebook,
          Instagram,
          WhatsApp,
          Browser,
          Snapchat,
          GoogleMaps,
          Twitter,
          LinkedIn,
          Telegram,
          YouTube,
          Pinterest,
          PDFDownloader,
          profileImage,
          coverImage, // Use the URL directly
          heading,
          mediaType,
          mobile,
          BusinessWhatsApp,
          Skype,
          massenger,
          wechat,
          FaceTime,
          showAllReviews,
          tagLine,
          insertedBy
        )
      );

      dispatch(set_snack_bar(true, "Link added successfully."));
      dispatch(setLoader(false));
    } else if (coverImage) {

      const validImageTypes = [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "image/webp",
      ];
      const validVideoTypes = ["video/mp4", "video/webm", "video/ogg"];
      const isImage = validImageTypes.includes(coverImage.type);
      const isVideo = validVideoTypes.includes(coverImage.type);

      if (!isImage && !isVideo) {
        dispatch(
          set_snack_bar(
            true,
            "Invalid file type. Only JPEG, PNG, JPG, WEBP images and MP4, WEBM, OGG videos are allowed."
          )
        );
        dispatch(setLoader(false));
        return;
      }


      const fileName = `${coverImage.name}-${Math.random()
        .toString(36)
        .substr(2, 9)}`;
      const storageRef = ref(getStorage(), `/uploads/${fileName}`);


      const uploadTask = uploadBytesResumable(storageRef, coverImage);

      uploadTask.on(
        "state_changed",
        (snapshot) => { },
        (error) => {
          console.error("File upload failed:", error);
          dispatch(set_snack_bar(true, "File could not be uploaded."));
          dispatch(setLoader(false));
        },
        () => {

          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            dispatch(
              addLink(
                token,
                user_id,
                Facebook,
                Instagram,
                WhatsApp,
                Browser,
                Snapchat,
                GoogleMaps,
                Twitter,
                LinkedIn,
                Telegram,
                YouTube,
                Pinterest,
                PDFDownloader,
                profileImage,
                downloadURL, // Use uploaded file URL
                heading,
                mediaType,
                mobile,
                BusinessWhatsApp,
                Skype,
                massenger,
                wechat,
                FaceTime,
                showAllReviews,
                tagLine,
                insertedBy
              )
            );
            dispatch(set_snack_bar(true, "File uploaded successfully."));
            dispatch(setLoader(false));
          });
        }
      );
    } else {

      dispatch(
        UploadsaddLink(
          token,
          user_id,
          Facebook,
          Instagram,
          WhatsApp,
          Browser,
          Snapchat,
          GoogleMaps,
          Twitter,
          LinkedIn,
          Telegram,
          YouTube,
          Pinterest,
          PDFDownloader,
          profileImage, // Pass the profile image URL
          coverImage,
          heading,
          mediaType,
          mobile,
          BusinessWhatsApp,
          Skype,
          massenger,
          wechat,
          FaceTime,
          showAllReviews,
          tagLine,
          insertedBy
        )
      );
      dispatch(set_snack_bar(true, "Please provide a cover image or video."));
      dispatch(setLoader(false));
    }
  };
}

export function addLink(
  token,
  user_id,
  Facebook,
  Instagram,
  WhatsApp,
  Browser,
  Snapchat,
  GoogleMaps,
  Twitter,
  LinkedIn,
  Telegram,
  YouTube,
  Pinterest,
  PDFDownloader,
  profileImage, // Pass the profile image URL
  coverImage,
  heading,
  mediaType, // Keep as is or modify accordingly
  mobile,
  BusinessWhatsApp,
  Skype,
  massenger,
  wechat,
  FaceTime,
  showAllReviews,
  tagLine,
  insertedBy
) {
  return (dispatch) => {
    dispatch(setLoader());
    return fetch(UNIVERSAL.BASEURL + "link/register", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        token,
      },
      body: JSON.stringify({
        Facebook,
        Instagram,
        WhatsApp,
        Browser,
        Snapchat,
        GoogleMaps,
        Twitter,
        LinkedIn,
        Telegram,
        YouTube,
        Pinterest,
        PDFDownloader,
        profileImage,
        coverImage,
        heading,
        mediaType,
        admin_id: user_id,
        mobile,
        BusinessWhatsApp,
        Skype,
        massenger,
        wechat,
        FaceTime,
        showAllReviews,
        tagLine,
        insertedBy,
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (
          responseJson.statusCode === 200 ||
          responseJson.statusCode === 201
        ) {
          dispatch(viewAllLinks(token, user_id, "", "", "", ""));
          dispatch(viewLinkById(user_id, token));
          dispatch(unsetLoader());
          dispatch(set_snack_bar(responseJson.status, responseJson.message));
        } else if (
          responseJson.statusCode === 401 ||
          responseJson.statusCode === 404
        ) {
          dispatch(viewAllLinks(token, user_id, "", "", "", ""));
          dispatch(viewLinkById(user_id, token));
          dispatch(set_snack_bar(responseJson.status, responseJson.message));
          dispatch(unsetLoader());
        }
      })
      .catch((error) => {
        dispatch(unsetLoader());
        dispatch(set_snack_bar(true, "Check Your Internet Connection"));

      });
  };
}

export function viewAllLinks(
  token,
  user_id,
  searchInput,
  page,
  pageSize,
  startDate,
  endDate,
  selectedStatus
) {
  return (dispatch) => {
    dispatch(setLoader());
    return fetch(UNIVERSAL.BASEURL + "link/view", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        token,
      },
      body: JSON.stringify({
        searchTerm: searchInput,
        user_id,
        page: parseInt(page),
        pageSize,
        startDate,
        endDate,
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (
          responseJson.statusCode === 200 ||
          responseJson.statusCode === 201
        ) {
          dispatch({
            type: CONSTANT.ALLLINKS,
            payload: responseJson.data.data,
            count: responseJson.data.totalLinks,
          });
          dispatch(unsetLoader());

        } else if (
          responseJson.statusCode === 401 ||
          responseJson.statusCode === 404
        ) {
          dispatch({ type: CONSTANT.ALLLINKS, payload: [], count: 0 });
          dispatch(set_snack_bar(responseJson.status, responseJson.message));
          dispatch(unsetLoader());
        }
      })
      .catch((error) => {
        dispatch(unsetLoader());
        dispatch(set_snack_bar(true, "Check Your Internet Connection"));

      });
  };
}




export function viewLinkByUserName(username) {
  return (dispatch) => {
    dispatch(setLoader());
    return fetch(UNIVERSAL.BASEURL + "link/viewLinkByUserName", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username: username,
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (
          responseJson.statusCode === 200 ||
          responseJson.statusCode === 201
        ) {
          dispatch({
            type: CONSTANT.ALLLINKSBYUSER,
            payload: responseJson.data.result,
          });
          dispatch(unsetLoader());

        } else if (
          responseJson.statusCode === 401 ||
          responseJson.statusCode === 404
        ) {
          dispatch({ type: CONSTANT.ALLLINKSBYUSER, payload: {} });
          dispatch(set_snack_bar(responseJson.status, responseJson.message));
          dispatch(unsetLoader());
        }
      })
      .catch((error) => {
        dispatch(unsetLoader());
        dispatch(set_snack_bar(true, "Check Your Internet Connection"));

      });
  };
}

export function giveFeedBack(username, rating, name, email, mobile, desc) {
  return (dispatch) => {
    dispatch(setLoader());
    return fetch(UNIVERSAL.BASEURL + "feedback/register", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username,
        rating,
        name,
        email,
        mobile,
        desc,
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (
          responseJson.statusCode === 200 ||
          responseJson.statusCode === 201
        ) {
          dispatch(setTankYou(true));
          dispatch(unsetLoader());
          dispatch(set_snack_bar(responseJson.status, responseJson.message));
        } else if (
          responseJson.statusCode === 401 ||
          responseJson.statusCode === 404
        ) {
          dispatch();
          dispatch(set_snack_bar(responseJson.status, responseJson.message));
          dispatch(unsetLoader());
        }
      })
      .catch((error) => {
        dispatch(unsetLoader());
        dispatch(set_snack_bar(true, "Check Your Internet Connection"));

      });
  };
}

export function setTankYou(payload) {
  return {
    type: CONSTANT.THANKYOU,
    payload: payload,
  };
}

export function viewLinkById(user_id, token) {
  return (dispatch) => {
    dispatch(setLoader());
    return fetch(UNIVERSAL.BASEURL + "link/viewLinkById", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        token,
      },
      body: JSON.stringify({
        admin_id: user_id,
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (
          responseJson.statusCode === 200 ||
          responseJson.statusCode === 201
        ) {
          dispatch({
            type: CONSTANT.ALLLINKSBYADMIN,
            payload: responseJson.data.result,
          });
          dispatch(unsetLoader());



        } else if (
          responseJson.statusCode === 401 ||
          responseJson.statusCode === 404
        ) {
          dispatch({ type: CONSTANT.ALLLINKSBYADMIN, payload: {} });
          dispatch(set_snack_bar(responseJson.status, responseJson.message));
          dispatch(unsetLoader());
        }
      })
      .catch((error) => {
        dispatch(unsetLoader());
        dispatch(set_snack_bar(true, "Check Your Internet Connection"));

      });
  };
}


export function UploadupdateLink(
  token,
  user_id,
  id,
  Facebook,
  Instagram,
  WhatsApp,
  Browser,
  Snapchat,
  GoogleMaps,
  Twitter,
  LinkedIn,
  Telegram,
  YouTube,
  Pinterest,
  PDFDownloader,
  heading,
  mediaType,
  mobile,
  BusinessWhatsApp,
  Skype,
  massenger,
  wechat,
  FaceTime,
  coverImage,
  newcoverImage,
  profileImage,
  newprofileImage,
  showAllReviews,
  tagLine,
  insertedBy
) {
  return (dispatch) => {
    dispatch(setLoader(true)); // Show loader


    if (newprofileImage) {
      const validImageTypes = [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "image/webp",
      ]; // Allowable file types
      if (!validImageTypes.includes(newprofileImage.type)) {
        dispatch(
          set_snack_bar(
            true,
            "Invalid image type. Only JPEG, PNG, and JPG are allowed."
          )
        );
        dispatch(setLoader(false));
        return;
      }


      const imageName = `${newprofileImage.name}-${Math.random()
        .toString(36)
        .substr(2, 9)}`;
      const storageRef = ref(getStorage(), `/uploads/${imageName}`);


      const uploadTask = uploadBytesResumable(storageRef, newprofileImage);

      uploadTask.on(
        "state_changed",
        (snapshot) => { },
        (error) => {
          console.error("Image upload failed:", error);
          dispatch(set_snack_bar(true, "Image could not be uploaded."));
          dispatch(setLoader(false)); // Hide loader on error
        },
        () => {

          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            dispatch(
              UploadupdateLinks(
                token,
                user_id,
                id,
                Facebook,
                Instagram,
                WhatsApp,
                Browser,
                Snapchat,
                GoogleMaps,
                Twitter,
                LinkedIn,
                Telegram,
                YouTube,
                Pinterest,
                PDFDownloader,
                heading,
                mediaType,
                mobile,
                BusinessWhatsApp,
                Skype,
                massenger,
                wechat,
                FaceTime,
                coverImage,
                newcoverImage,
                downloadURL,
                showAllReviews,
                tagLine,
                insertedBy
              )
            );
            dispatch(set_snack_bar(true, "Image uploaded successfully."));
            dispatch(setLoader(false)); // Hide loader
          });
        }
      );
    } else {

      dispatch(
        UploadupdateLinks(
          token,
          user_id,
          id,
          Facebook,
          Instagram,
          WhatsApp,
          Browser,
          Snapchat,
          GoogleMaps,
          Twitter,
          LinkedIn,
          Telegram,
          YouTube,
          Pinterest,
          PDFDownloader,
          heading,
          mediaType,
          mobile,
          BusinessWhatsApp,
          Skype,
          massenger,
          wechat,
          FaceTime,
          coverImage,
          newcoverImage,
          profileImage,
          showAllReviews,
          tagLine,
          insertedBy
        )
      );
      dispatch(set_snack_bar(true, "Please upload a profile image."));
      dispatch(setLoader(false));
    }
  };
}

export function UploadupdateLinks(
  token,
  user_id,
  id,
  Facebook,
  Instagram,
  WhatsApp,
  Browser,
  Snapchat,
  GoogleMaps,
  Twitter,
  LinkedIn,
  Telegram,
  YouTube,
  Pinterest,
  PDFDownloader,
  heading,
  mediaType,
  mobile,
  BusinessWhatsApp,
  Skype,
  massenger,
  wechat,
  FaceTime,
  coverImage,
  newcoverImage,
  profileImage,
  showAllReviews,
  tagLine,
  insertedBy
) {
  return (dispatch) => {
    dispatch(setLoader(true)); // Show loader

    if (newcoverImage) {

      const validImageTypes = [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "image/webp",
      ];
      const validVideoTypes = ["video/mp4", "video/webm", "video/ogg"];
      const isImage = validImageTypes.includes(newcoverImage.type);
      const isVideo = validVideoTypes.includes(newcoverImage.type);

      if (!isImage && !isVideo) {
        dispatch(
          set_snack_bar(
            true,
            "Invalid file type. Only JPEG, PNG, JPG, WEBP images and MP4, WEBM, OGG videos are allowed."
          )
        );
        dispatch(setLoader(false));
        return;
      }


      const fileName = `${newcoverImage.name}-${Math.random()
        .toString(36)
        .substr(2, 9)}`;
      const storageRef = ref(getStorage(), `/uploads/${fileName}`);


      const uploadTask = uploadBytesResumable(storageRef, newcoverImage);

      uploadTask.on(
        "state_changed",
        (snapshot) => { },
        (error) => {
          console.error("File upload failed:", error);
          dispatch(set_snack_bar(true, "File could not be uploaded."));
          dispatch(setLoader(false));
        },
        () => {

          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            dispatch(
              updaetsLinks(
                token,
                user_id,
                id,
                Facebook,
                Instagram,
                WhatsApp,
                Browser,
                Snapchat,
                GoogleMaps,
                Twitter,
                LinkedIn,
                Telegram,
                YouTube,
                Pinterest,
                PDFDownloader,
                heading,
                mediaType,
                mobile,
                BusinessWhatsApp,
                Skype,
                massenger,
                wechat,
                FaceTime,
                downloadURL,
                profileImage,
                showAllReviews,
                tagLine,
                insertedBy
              )
            );
            dispatch(set_snack_bar(true, "File uploaded successfully."));
            dispatch(setLoader(false));
          });
        }
      );
    } else {

      dispatch(
        updaetsLinks(
          token,
          user_id,
          id,
          Facebook,
          Instagram,
          WhatsApp,
          Browser,
          Snapchat,
          GoogleMaps,
          Twitter,
          LinkedIn,
          Telegram,
          YouTube,
          Pinterest,
          PDFDownloader,
          heading,
          mediaType,
          mobile,
          BusinessWhatsApp,
          Skype,
          massenger,
          wechat,
          FaceTime,
          coverImage,
          profileImage,
          showAllReviews,
          tagLine,
          insertedBy
        )
      );
      dispatch(set_snack_bar(true, "Please provide a cover image or video."));
      dispatch(setLoader(false));
    }
  };
}

export function updaetsLinks(
  token,
  user_id,
  id,
  Facebook,
  Instagram,
  WhatsApp,
  Browser,
  Snapchat,
  GoogleMaps,
  Twitter,
  LinkedIn,
  Telegram,
  YouTube,
  Pinterest,
  PDFDownloader,
  heading,
  mediaType,
  mobile,
  BusinessWhatsApp,
  Skype,
  massenger,
  wechat,
  FaceTime,
  coverImage,
  profileImage,
  showAllReviews,
  tagLine,
  insertedBy
) {
  return (dispatch) => {
    dispatch(setLoader());
    return fetch(UNIVERSAL.BASEURL + "link/update", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        token,
      },
      body: JSON.stringify({
        id,
        Facebook,
        Instagram,
        WhatsApp,
        Browser,
        Snapchat,
        GoogleMaps,
        Twitter,
        LinkedIn,
        Telegram,
        YouTube,
        Pinterest,
        PDFDownloader,
        profileImage,
        coverImage,
        heading,
        mediaType,
        mobile,
        BusinessWhatsApp,
        Skype,
        massenger,
        wechat,
        FaceTime,
        admin_id: user_id,
        showAllReviews,
        tagLine,
        insertedBy,
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (
          responseJson.statusCode === 200 ||
          responseJson.statusCode === 201
        ) {
          dispatch(viewAllLinks(token, user_id, "", "", "", ""));
          dispatch(viewLinkById(user_id, token));

          dispatch(unsetLoader());
          dispatch(set_snack_bar(responseJson.status, responseJson.message));
        } else if (
          responseJson.statusCode === 401 ||
          responseJson.statusCode === 404
        ) {
          dispatch(viewLinkById(user_id, token));
          dispatch(viewAllLinks(token, user_id, "", "", "", ""));
          dispatch(set_snack_bar(responseJson.status, responseJson.message));
          dispatch(unsetLoader());
        }
      })
      .catch((error) => {
        dispatch(unsetLoader());
        dispatch(set_snack_bar(true, "Check Your Internet Connection"));

      });
  };
}


export function viewAllBadReview(
  token,
  user_id,
  searchInput,
  page,
  pageSize,
  startDate,
  endDate,
  selectedStatus
) {
  return (dispatch) => {
    dispatch(setLoader());
    return fetch(UNIVERSAL.BASEURL + "feedback/view", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        token,
      },
      body: JSON.stringify({
        user_id,
        searchInput,
        page: parseInt(page),
        pageSize,
        startDate,
        endDate,
        selectedStatus,
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (
          responseJson.statusCode === 200 ||
          responseJson.statusCode === 201
        ) {
          dispatch({
            type: CONSTANT.BADFEEDBACK,
            payload: responseJson.data.data,
            count: responseJson.data.totalfeedbacks,
          });
          dispatch(unsetLoader());
          dispatch(set_snack_bar(responseJson.status, responseJson.message));
        } else if (
          responseJson.statusCode === 401 ||
          responseJson.statusCode === 404
        ) {
          dispatch({ type: CONSTANT.BADFEEDBACK, payload: [], count: 0 });
          dispatch(set_snack_bar(responseJson.status, responseJson.message));
          dispatch(unsetLoader());
        }
      })
      .catch((error) => {
        dispatch(unsetLoader());
        dispatch(set_snack_bar(true, "Check Your Internet Connection"));

      });
  };
}

export function setModal() {
  return {
    type: CONSTANT.MODAL,
    payload: true,
  };
}

export function setModalfalse() {
  return {
    type: CONSTANT.MODAL,
    payload: false,
  };
}


export function viewNavitemsById(user_id, token) {
  return (dispatch) => {
    dispatch(setLoader());
    return fetch(UNIVERSAL.BASEURL + "navitem/viewNavitemsByadmin", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        token,
      },
      body: JSON.stringify({
        user_id,
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (
          responseJson.statusCode === 200 ||
          responseJson.statusCode === 201
        ) {
          dispatch({
            type: CONSTANT.VIEWNAVITEMBYID,
            payload: responseJson.data,
            count: responseJson.data.length,
          });
          dispatch(unsetLoader());
          dispatch(set_snack_bar(responseJson.status, responseJson.message));
        } else if (
          responseJson.statusCode === 401 ||
          responseJson.statusCode === 404
        ) {
          dispatch({ type: CONSTANT.VIEWNAVITEMBYID, payload: [], count: 0 });

          dispatch(unsetLoader());
        }
      })
      .catch((error) => {
        dispatch(unsetLoader());
        dispatch(set_snack_bar(true, "Check Your Internet Connection"));

      });
  };
}

export function viewTitleByUserName(username) {
  return (dispatch) => {
    dispatch(setLoader());
    return fetch(UNIVERSAL.BASEURL + "link/viewTitleByUserName", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username,
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (
          responseJson.statusCode === 200 ||
          responseJson.statusCode === 201
        ) {
          dispatch({
            type: CONSTANT.VIEWTITLE,
            payload: responseJson.data,
          });
          dispatch(unsetLoader());

        } else if (
          responseJson.statusCode === 401 ||
          responseJson.statusCode === 404
        ) {
          dispatch({ type: CONSTANT.VIEWTITLE, payload: [] });

          dispatch(unsetLoader());
        }
      })
      .catch((error) => {
        dispatch(unsetLoader());
        dispatch(set_snack_bar(true, "Check Your Internet Connection"));

      });
  };
}




export function viewLogedInDevice(token, admin_id) {
  return (dispatch) => {

    return fetch(UNIVERSAL.BASEURL + "user/getLogedInUser", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        token,
      },
      body: JSON.stringify({
        user_id: admin_id,
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (
          responseJson.statusCode === 200 ||
          responseJson.statusCode === 201
        ) {
          dispatch({
            type: CONSTANT.LOGEDIN_DEVICE,
            payload: responseJson.data.sessions,
          });

          dispatch(set_snack_bar(responseJson.status, responseJson.message));
        } else if (
          responseJson.statusCode === 401 ||
          responseJson.statusCode === 404
        ) {
          dispatch({ type: CONSTANT.LOGEDIN_DEVICE, payload: [] });


        }
      })
      .catch((error) => {

        dispatch(set_snack_bar(true, "Check Your Internet Connection"));

      });
  };
}

export function viewById(token, admin_id) {
  return (dispatch) => {

    return fetch(UNIVERSAL.BASEURL + "user/view_by_id", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        token,
      },
      body: JSON.stringify({
        id: admin_id,
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (
          responseJson.statusCode === 200 ||
          responseJson.statusCode === 201
        ) {
          dispatch({
            type: CONSTANT.VIEW_BY_ID,
            payload: responseJson.data.result,
          });


        } else if (
          responseJson.statusCode === 401 ||
          responseJson.statusCode === 404
        ) {
          dispatch({ type: CONSTANT.VIEW_BY_ID, payload: [] });


        }
      })
      .catch((error) => {

        dispatch(set_snack_bar(true, "Check Your Internet Connection"));

      });
  };
}


export function updateProfile(token, user_id, data) {
  return (dispatch) => {
    dispatch(setLoader(true));
    return fetch(UNIVERSAL.BASEURL + "user/update", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        token: token,
      },
      body: JSON.stringify({

        id: user_id,
        insertedBy: user_id,
        ...data
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson.statusCode === 200 || responseJson.statusCode === 201) {
          dispatch(set_snack_bar(true, "Profile updated successfully"));
          // Optionally Update Redux State here if needed
        } else {
          dispatch(set_snack_bar(true, responseJson.message || "Update failed"));
        }
        dispatch(setLoader(false));
      })
      .catch((error) => {
        console.error(error);
        dispatch(set_snack_bar(true, "Check Your Internet Connection"));
        dispatch(setLoader(false));
      });
  };
}

export function SendReport(token, user_id) {
  return (dispatch) => {
    dispatch(setLoader());
    return fetch(
      UNIVERSAL.BASEURL + "invoice/sendDailySalesEmailForUser",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          token,
        },
        body: JSON.stringify({
          admin_id: user_id,
        }),
      }
    )
      .then((response) => response.json())
      .then((responseJson) => {
        if (
          responseJson.statusCode === 200 ||
          responseJson.statusCode === 201
        ) {
          dispatch(unsetLoader());
          dispatch(set_snack_bar(responseJson.status, responseJson.message));
        } else if (
          responseJson.statusCode === 401 ||
          responseJson.statusCode === 404
        ) {
          dispatch(unsetLoader());
        }
      })
      .catch((error) => {
        dispatch(unsetLoader());
        dispatch(set_snack_bar(true, "Check Your Internet Connection"));

      });
  };
}

